import { Avatar } from 'antd';
import React, { useMemo } from 'react';
import type File from '../../../interfaces/File';
import { getAvatarColor } from '../../../utils/avatarColors';
import TruncatedTooltip from '../../Common/TruncatedTooltip';

interface FilesTableCreatedByCellProps {
  file: File;
}

/** "Luca Admin (email@example.com)" → "Luca Admin" */
export function getCreatedByDisplayLabel(createdBy: string): string {
  const nameWithEmailMatch = createdBy.match(/^(.+?)\s*\([^)]*\)\s*$/);
  return nameWithEmailMatch?.[1]?.trim() ?? createdBy.trim();
}

function hashStringToPositiveInt(value: string): number {
  let hash = 0;
  for (let index = 0; index < value.length; index++) {
    const charCode = value.charCodeAt(index);
    hash = (hash << 5) - hash + charCode;
    hash = hash & hash;
  }
  return Math.abs(hash);
}

const FilesTableCreatedByCell: React.FC<FilesTableCreatedByCellProps> = ({ file }) => {
  const createdBy = file.createdBy?.trim() ?? '';

  const createdById = useMemo(
    () => (createdBy ? hashStringToPositiveInt(createdBy) : 0),
    [createdBy],
  );

  const displayLabel = useMemo(
    () => (createdBy ? getCreatedByDisplayLabel(createdBy) : ''),
    [createdBy],
  );

  if (!createdBy) {
    return <span className="text-gray-dark">-</span>;
  }

  return (
    <div className="flex w-full min-w-0 flex-row items-center gap-2">
      <Avatar
        className="text-blue-dark! shrink-0!"
        style={{ backgroundColor: getAvatarColor(createdById) }}
      >
        {displayLabel[0]?.toUpperCase()}
      </Avatar>
      <span className="min-w-0 flex-1 overflow-hidden">
        <span className="block w-full min-w-0 overflow-hidden">
          <TruncatedTooltip className="block w-full min-w-0">{createdBy}</TruncatedTooltip>
        </span>
      </span>
    </div>
  );
};

export default FilesTableCreatedByCell;
